var map = {
	"./i/c.jpg": "572e",
	"./ii/c.jpg": "d510",
	"./iii/c.jpg": "8670",
	"./iv/c.jpg": "abcc",
	"./ix/c.jpg": "a12c",
	"./v/c.jpg": "8c01",
	"./vi/c.jpg": "1c8d",
	"./vii/c.jpg": "0adb",
	"./viii/c.jpg": "35aa",
	"./writing/c.jpg": "ab05",
	"./x/c.jpg": "ba35",
	"./xi/c.jpg": "74c3",
	"./xii/c.jpg": "3a3a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79d5";